import { EpgApi } from '../../api/EpgApi';
import { ActionMethod, AssetType } from '../../api/models/Shared.types';
import { EpgUtil } from '../utility/EpgUtil';
import { Log } from '@lightningjs/sdk';
import { IRibbon2Asset, ISeasonSummary } from '../../api/models/AndromeTV.types';
import { Backend } from '../../api/Backend';
import { Recording } from '../../api/user/RecordingApi.types';

export function recordingToRibbon2Asset(backend: Backend, recording: Recording): Promise<IRibbon2Asset> {
  return EpgApi.schedule(backend, recording.schedule)
    .then(schedule => {
      const seasons = [schedule.season].filter(s => s) as ISeasonSummary[];
      const asset: IRibbon2Asset = {
        asset: {
          type: AssetType.RECORDING,
          id: recording.identifier,
          image: schedule.program.posterImage || '',
          title: '',
          episode: recording.programOrdinal,
        },
        method: ActionMethod.DETAIL,
        channels: EpgUtil.schedulesToRibbon2Channels([schedule.schedule]),
        resources: [EpgUtil.programToRibbon2Detail(schedule.program, seasons)],
      };
      return asset;
    })
    .catch(error => {
      Log.error('Failed to fetch schedule for recording, falling back on programfallback: ', error);
      return recordingFallback(backend, recording);
    });
}

function recordingFallback(backend: Backend, recording: Recording): Promise<IRibbon2Asset> {
  const fromuntil = EpgUtil.epgFromUntil(backend);
  return EpgApi.program(
    backend,
    recording.program,
    fromuntil.from,
    fromuntil.until,
    backend.deviceProfile?.profile.catalog
  ).then(result => {
    const seasons = [result.season].filter(s => s) as ISeasonSummary[];
    const asset: IRibbon2Asset = {
      asset: {
        type: AssetType.RECORDING,
        id: recording.identifier,
        image: result.program.posterImage || '',
        title: result.program.title,
        episode: recording.programOrdinal,
      },
      method: ActionMethod.DETAIL,
      channels: [
        {
          id: recording.channel,
          schedules: [
            {
              id: '',
              programId: result.program.id,
              published: { start: recording.effectiveStart || '', end: recording.effectiveEnd || '' },
            },
          ],
        },
      ],
      resources: [EpgUtil.programToRibbon2Detail(result.program, seasons)],
    };
    return asset;
  });
}
